<script setup>
defineProps({
  size: {
    type: String,
    default: 'medium',
  },
  color: {
    type: String,
    default: 'brand',
  },
})
</script>

<template>
  <div style="height: 6rem; position: relative">
    <div
      role="status"
      class="slds-spinner"
      :class="[`slds-spinner_${size}`, `slds-spinner_${color}`]"
    >
      <span class="slds-assistive-text">Loading</span>
      <div class="slds-spinner__dot-a"></div>
      <div class="slds-spinner__dot-b"></div>
    </div>
  </div>
</template>

<style scoped>
@import '@salesforce-ux/design-system/css/spinners/base/index.css';

.slds-assistive-text {
  position: absolute !important;
  margin: -1px !important;
  border: 0 !important;
  padding: 0 !important;
  width: 1px !important;
  height: 1px !important;
  overflow: hidden !important;
  clip: rect(0 0 0 0) !important;
  text-transform: none !important;
  white-space: nowrap !important;
}
</style>
